import comfortImage from './images/customer-story_comfort.jpg';
import energysavingsImage from './images/customer-story_energy-savings.jpg';
import noisecommercialImage from './images/customer-story_noise-commercial.jpg';
import noisereductionImage from './images/customer-story_noise-reduction.jpg';
import privacyImage from './images/customer-story_privacy.jpg';
import sleepPanelImage from './images/customer-story_sleep.jpg';
import thisOldHouseImage from './images/customer-story_this-old-house.jpg';
import uvImage from './images/customer-story_uv.jpg';

export const comfortCustomerStory = {
	body: 'A couple in a historic home used Indow inserts as a cost-effective, non-invasive alternative to window replacement, preserving aesthetics while improving comfort and energy savings.',
	quote:
		"Using Indow inserts, the space heats up fast and it stays warm for hours, even after I switch off the space heater. It's actually more comfortable to sit on the sofa next to an Indow insert than it is to sit next to the brand new double panes.",
	name: 'Craig & Shari S',
	url: '/resources/case-studies/window-replacement-alternative',
	image: comfortImage,
};
export const energySavingsCustomerStory = {
	body: 'The U.S. Department of Energy found Indow inserts lead to a 20 percent reduction in heating and cooling costs in a Seattle home.',
	quote:
		"You can take a 100-year-old historic home and.. make it as energy efficient as a new building. The biggest difference I noticed was the sound reduction - I'm on a residential street but you get a whole lot of noise penetration with single-pane windows.",
	name: 'Aileen G',
	url: '/resources/case-studies/energy-efficiency-old-homes',
	image: energysavingsImage,
};
export const noiseCommercialCustomerStory = {
	body: "This building manager installed Indow inserts to soundproof his tenants' offices, and was blown away by the impressive reduction in sound.",
	quote:
		'Acoustic Grade Indow window inserts seemed to be the only solution to insulate the train noise. We realized that if we fixed our window problem we could lease the space for market rates, instead of leasing far below market. The return on the investment has been outstanding and we like happy tenants!',
	name: 'Mike L',
	url: '/resources/case-studies/office-soundproofing',
	image: noisecommercialImage,
};
export const noiseReductionCustomerStory = {
	body: 'Constant traffic noise made it hard for this family to sleep and almost forced them to move before they found Indow inserts.',
	quote:
		"After moving in, we realized just how busy the street was because it was so noisy we could not sleep at all. Neither could our infant. (The inserts) came on time and were installed so easily, I couldn't believe it! The difference in sound was unbelievable.",
	name: 'Maggie F',
	url: '/resources/case-studies/street-noise-reduction',
	image: noisereductionImage,
};
export const privacyCustomerStory = {
	body: 'Privacy Grade inserts helped one urban dweller shield his home from view of hotel guests next door while reducing grime filtering through his windows.',
	quote:
		"I love the Indow window privacy grade insert. It's sleek and modern. I didn't want to seal the windows off — this allows light into the unit.",
	name: 'Eric S',
	url: '/resources/case-studies/window-privacy-ideas',
	image: privacyImage,
};
export const uvCustomerStory = {
	body: 'Owners of the iconic Case Study House #26 in California used inserts to protect paintings from damaging UV rays and insulate their historic home.',
	quote:
		"I am amazed at how well they fit in and how easy they were to install, there was a noticeable difference right away and they didn't damage a thing.",
	name: 'Cord S',
	url: '/resources/case-studies/block-cold-from-windows',
	image: uvImage,
};
export const thisOldHouseCustomerStory = {
	body: 'Indow joined This Old House to help Scott and Kathleen block out noise and cold drafts in their charming Charleston home amidst their bustling Ansonborough neighborhood.',
	quote:
		"It's like a house with double or triple-pane windows. I hear very little. You walk by a window and there's no draft.",
	name: 'Scott E',
	url: '/resources/case-studies/this-old-house-charleston',
	image: thisOldHouseImage,
};
export const sleepPanelCustomerStory = {
	body: 'Indow Sleep Panels helped a night shift worker capture eight hours of dark, quiet, restful daytime sleep - and even helped her husband sleep better through nighttime noise.',
	quote:
		"It's completely different now. You're in a comfortable, dark space. What we hear is what we want to hear - which is silence.",
	name: 'Brad',
	url: '/resources/case-studies/sleep-panels-total-darkness',
	image: sleepPanelImage,
};
